import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/opt/suncore/build/20261103T154933Z-259fdf9d/app/layouts/login.vue").then(m => m.default || m))
}